import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["status"]
  static values = { url: String, interval: { type: Number, default: 4000 } }

  connect() {
    if (!this.isComplete()) this.schedule()
  }

  disconnect() {
    this.stop()
  }

  schedule() {
    this.timer = setInterval(() => this.refresh(), this.intervalValue)
  }

  stop() {
    clearInterval(this.timer)
  }

  async refresh() {
    const response = await fetch(this.urlValue, {
      headers: { Accept: "text/vnd.turbo-stream.html" }
    })

    if (response.ok) {
      Turbo.renderStreamMessage(await response.text())
    }

    if (this.isComplete()) this.stop()
  }

  isComplete() {
    return this.hasStatusTarget && this.statusTarget.dataset.status === "completed"
  }
}
